import { saleorAuthClient } from '@/graphql/client';
import { getUtmFieldsCamelCase } from '@/lib/campaignTracker';
import { paths } from '@/lib/paths';

interface WatchAvailGuestParams {
  boutiqueId: string;
  comments?: string;
  email: string;
  firstName: string;
  languageCode: string;
  lastName: string;
  newsletterOptIn: boolean;
  phone?: string;
  productSku: string;
  recaptchaResponse: string;
  salutation: string;
  source?: string;
  websiteCountryCode: string;
}
interface WatchAvailParams {
  boutiqueId: string;
  comments?: string;
  languageCode: string;
  newsletterOptIn: boolean;
  productSku: string;
  recaptchaResponse: string;
  websiteCountryCode: string;
}
export const watchAvailGuest = async (params: WatchAvailGuestParams) => {
  const utmFields = getUtmFieldsCamelCase(params.websiteCountryCode);
  const paramsWithUtm = {
    ...params,
    ...utmFields,
  };
  const appointmentRes = await saleorAuthClient.fetchWithAuth(
    paths.api.watchAvailGuest,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paramsWithUtm),
      cache: 'no-store',
    },
    { allowPassingTokenToThirdPartyDomains: true },
  );

  return await appointmentRes.json();
};

export const watchAvail = async (params: WatchAvailParams) => {
  const utmFields = getUtmFieldsCamelCase(params.websiteCountryCode);
  const paramsWithUtm = {
    ...params,
    ...utmFields,
  };
  const appointmentRes = await saleorAuthClient.fetchWithAuth(
    paths.api.watchAvail,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(paramsWithUtm),
      cache: 'no-store',
    },
    { allowPassingTokenToThirdPartyDomains: true },
  );

  return await appointmentRes.json();
};
